// rdrive's shared vocabulary (PLATFORM.md §6 decision 22): the words every rdrive dashboard
// uses with the same meaning — page and entity names, the item and document model, generic UI
// labels, fallback labels, totals and user/team scopes. Strings only: one JSON per locale + this
// barrel, the same format as the app's `src/locales/` and every package `messages/` folder.
//
// An APP registers it at the root, UNDER its own strings: it passes it to `createDashboard`
// (`@rdrive/plugin-dashboard-shell`, since Phase 1 step 6b-2a), which builds the root bundle as
// `mergeMessages(vocabulary, messages)` from `@rdrive/i18n` — the shell never imports it. A package
// component never relies on it through the root composer: it keeps its own copy in its
// `messages/` folder (decision 15; README "Rules").
//
// - Admission: a key enters only if at least two apps use it with the same meaning AND it reads
//   correctly on any rdrive dashboard (an rdrive data-model term, a page or entity name, a
//   generic UI label; never a page title, a one-chart tooltip or a file name).
// - One home per key: a key lives here OR in an app bundle, never both. Under `mergeMessages`
//   the app's copy would win silently; `pnpm i18n:extract` reports any such key under OVERRIDES.
// - Values are reviewed fleet-wide: a change here changes every dashboard, so review it through
//   `pnpm i18n:extract`'s per-locale output (group `vocabulary`), like any other string change.
//
// Keep the imports plain: no `with { type: 'json' }` (Vite serves transformed JSON as
// JavaScript and the browser rejects the attribute). Node proof scripts need a `load` hook.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
